import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\PeppolSendInvoice::__invoke
* @see app/Http/Controllers/Invoice/PeppolSendInvoice.php
* @route '/api/invoicing/{invoice}/peppol/send'
*/
const PeppolSendInvoice = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PeppolSendInvoice.url(args, options),
    method: 'post',
})

PeppolSendInvoice.definition = {
    methods: ["post"],
    url: '/api/invoicing/{invoice}/peppol/send',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\PeppolSendInvoice::__invoke
* @see app/Http/Controllers/Invoice/PeppolSendInvoice.php
* @route '/api/invoicing/{invoice}/peppol/send'
*/
PeppolSendInvoice.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return PeppolSendInvoice.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\PeppolSendInvoice::__invoke
* @see app/Http/Controllers/Invoice/PeppolSendInvoice.php
* @route '/api/invoicing/{invoice}/peppol/send'
*/
PeppolSendInvoice.post = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PeppolSendInvoice.url(args, options),
    method: 'post',
})

export default PeppolSendInvoice